import { NativeCalculateResult } from '@repo/types';
import { LocalStorageKey, getDynamicStorageKey } from '../localstorage';
import { deserialize, serialize } from '@repo/common-utils/serialize';

// Persisted snapshot of the member-card coverage committed at reserve. It survives a payment-gateway
// redirect/reload (where the in-memory committedResult is lost) so the confirmation/receipt can show
// how the member actually paid — the card coverage + the actual total — instead of the gross price.
// Written at reserve, restored on the confirmation, and dropped when a fresh checkout opens. Mirrors
// purchase.localstorage's dynamic-key + serialize pattern.
export function storeNativeCoverageSnapshot(result: NativeCalculateResult | null) {
    localStorage.setItem(
        getDynamicStorageKey(LocalStorageKey.NATIVE_MEMBER_COVERAGE),
        serialize(result),
    );
}

export function loadNativeCoverageSnapshot(): NativeCalculateResult | null {
    const serialized = localStorage.getItem(
        getDynamicStorageKey(LocalStorageKey.NATIVE_MEMBER_COVERAGE),
    );
    if (serialized) {
        return deserialize(serialized) as NativeCalculateResult;
    } else {
        return null;
    }
}
